(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.blogRelatedPosts = {
    attach: function (context, settings) {
      $(once('blogRelatedPosts', '.blog-related-posts')).each(function () {
        $('.blog-card-image').each(function () {
          var $image = $(this).children('img');
          var $title = $(this).siblings('.blog-card-title');

          // Remove max-height for the image so it can fill the container.
          if ($title.height() > $image.height()) {
            $image.removeClass('max-h-28 max-h-36');
          }
        });
      });
    }
  };

})(jQuery, Drupal, once);
